import { Component } from '@angular/core';

@Component({
  selector: 'app-cards7-examples-44',
  templateUrl: './cards7-examples-44.component.html'
})
export class Cards7Examples44Component {}
